/**
 * An outline `Button` that is the chosen one of a set (a day, a priority).
 * Overrides the outline variant's own surface, its dark-mode one included,
 * with the theme's highlight tint.
 */
export const SELECTED_OUTLINE_BUTTON =
  'border-highlight bg-highlight text-highlight-foreground hover:bg-highlight/80 hover:text-highlight-foreground dark:border-highlight dark:bg-highlight dark:hover:bg-highlight/80';
